import { LanguageKey } from '../../SDK/Language';
import { IDataSet } from '../Track';
import { Platform } from 'Utility/Platform';

export class MetaDataSet implements IDataSet {
    public gameVersion: number = undefined;
    public gameID: string = undefined;
    public timezoneOffset: string = undefined;
    public timezoneName: string = undefined;
    public platform: Platform = undefined;
    public platformUserID: string = undefined;
    public deviceType: string = undefined;
    public operatingSystem: string = undefined;
    public operatingSystemVersion: string = undefined;
    public screenHeight: number = undefined;
    public screenWidth: number = undefined;
    public renderer: 'unknown' | 'webgl' | 'canvas' = 'unknown';
    public frameRate: number = undefined;
    //public durationSinceJSEnabled: number = undefined;
    public loadingTime: number = undefined;
    public timeUntilFirstUserInteractionPossible: number = undefined;
    public locale: LanguageKey = undefined;
    //public country: string = undefined;

    // Duplicate of `durationSinceJSEnabled`?
    //public timeSinceJSEnabled: number = undefined;

    public musicIsOn: number = undefined;
    public soundIsOn: number = undefined;

    //public error: string = undefined;

    public changerBooster: number = undefined;
    public removeOneBooster: number = undefined;
    public massRemoveBooster: number = undefined;

    public freeEntryBooster: number = undefined;
    public plus5Booster: number = undefined;

    /** Number of canister card pre-level boosters in inventory */
    public canisterCardBoosters: number = undefined;

    /** Number of joker card pre-level boosters in inventory */
    public extraWildcardsBoosters: number = undefined;

    /** Number of remove-cards pre-level boosters in inventory */
    public removeCardsBoosters: number = undefined;

    public jokerBooster: number = undefined;
    public undoBooster: number = undefined;
    public coins: number = undefined;
    public stars: number = undefined;

    public lastLevelAttempted: number = undefined;
    public lastLevelWon: number = undefined;
    public sessionNum: number = undefined;
    public highestLevel: number = undefined;

    public numFriendsInApp: number = undefined;
    public sdkVersion: string = undefined;

    /** How much real currency this user had spent (in dollars) */
    public realMoneySpent: number = undefined;

    /** How many real money purchases the user had made */
    public realMoneyPurchasesMade: number = undefined;

    /**
     * The number of coins bought with real money
     * The value of all the packages bought by the user with real money - in coins.
     * So, for example: if a user had bought with real money a package with 10,000 coins,
     * and then another package with 5,000 coins, one booster worth 1,500 coins,
     * and one worth 2,000 coins, this value would be: 10,000 + 5,000 + 1,500 + 2,000 = 18,500.
     * NOTE: this is only for packages bought by the user with real money.
     */
    public coinValueBoughtWithRealMoney: number = undefined;

    /** denotes how many stars are in the next star chest at the time of the event */
    public starsInNextChest: number = undefined;

    /** This will be 1 if the user had ever used the cheat codes, and 0 otherwise */
    public usedCheatCodes: 0 | 1 = undefined;

    /** These are the per-quest metadata params (1 to 3); _not unused_ */
    public quest1Name: string = undefined;
    public quest1ID: string = undefined;
    public quest1Tier: number = undefined;
    public quest1Progress: number = undefined;
    public quest2Name: string = undefined;
    public quest2ID: string = undefined;
    public quest2Tier: number = undefined;
    public quest2Progress: number = undefined;
    public quest3Name: string = undefined;
    public quest3ID: string = undefined;
    public quest3Tier: number = undefined;
    public quest3Progress: number = undefined;

    /** For tracking users last advertising campaign across sessions */
    public attributionCampaignID: string = undefined;

    /** My Farm slot unlock booleans (tracked as a number with a value of 0 or 1) */
    public plot1Unlocked: number = undefined;
    public plot2Unlocked: number = undefined;
    public plot3Unlocked: number = undefined;
    public plot4Unlocked: number = undefined;
}
